import { trpc } from '../../App'
import { useAuthContext } from './context/useAuthContext'

export function usePermissions() {
  const { authCtx } = useAuthContext()
  const rights = trpc.akte.permissions.useQuery({ role: authCtx?.roles?.join(',') ?? '' })
  return rights
}
